import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
import dayjs from "dayjs";
import { useMemo } from "react";
//#region src/modules/Locations/hooks/useLocationLogEntriesByDate.ts
function useLocationLogEntriesByDate(args, opts = {}) {
	const { call, data: entryListData, isCalling } = useRPC(RPCs.Locations.GetLocationLogEntryList.v2, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args?.locationId
	});
	return {
		data: useMemo(() => {
			if (!entryListData?.entries) return;
			return {
				entriesByDate: entryListData.entries.reduce((acc, entry) => {
					const date = dayjs(entry.createdAt).startOf("day").toISOString();
					if (!acc[date]) acc[date] = [];
					acc[date].push(entry);
					return acc;
				}, {}),
				total: entryListData.total
			};
		}, [entryListData]),
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useLocationLogEntriesByDate };

//# sourceMappingURL=useLocationLogEntriesByDate.js.map